module.exports = __webpack_public_path__ + "img/img.2a509861.png";